// Free digital drapes decline path (viral loop, PLAN-SUMMER-2026.md §5.5). Rollback = false + deploy.
export const FREE_DRAPES_V1 = true;
